import { useState, useRef, useEffect } from "react";

// ASSETS
import WarningIcon from "assets/icons/warning icon web.svg";
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import shareIcon from "assets/svg/ShareIcon.svg";
import ArrowUpIcon from "assets/svg/RightRedIcon.svg";
import evergencyPhoto from "assets/svg/HeaderPhotoUrgenta.svg";
import facebookIcon from "assets/svg/FacebookGrey.svg";
import linkedInIcon from "assets/svg/LinkedInGrey.svg";
import calendarIcon from "assets/svg/data.svg";
import covidImg from "assets/svg/PosterTelVerde.svg";
import XSign from "assets/svg/XSignModal.svg";

// STYLES
import {
  EmergencyCommunicationContainer,
  HeaderImageWrapper,
  HeaderImage,
  Body,
  FirstColumn,
  SecondColumn,
  ThirdColumn,
  BackToButton,
  BackToImage,
  BackToWrapper,
  TitleWrapper,
  ContentCard,
  SocialMediaCard,
  SocialMediaIcons,
  SocialMediaIcon,
  OtherGuidesCard,
  InsideFirstColumn,
  InsideThirdColumn,
  BackOnTopWrapper,
  BackOnTopImg,
  WrapperTitles,
  CopyToClipboardWrapper,
  CopyToClipboardTooltip,
  ImgLeft,
  CenterLeftCard,
  WrapperTexts,
  SubTitle,
  LeftCard,
  ImgLeftCard,
  ButtonWrapper,
  Modal,
  ModalContentWrapper,
  ModalCloseButton,
  XImg,
  ModalContent,
  ImgModal,
  CenterCardTitle,
  OtherChapters,
  ImgStyled,
  DetailsOtherEventsWrapper,
  OtherCampaignsContent,
  SkeletonWrapperOtherChapter,
  SkeletonWrapperChapter,
} from "./EmergencyCommunicationStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { LinkedinShareButton, FacebookShareButton } from "react-share";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS, DEVICE_TYPE } from "constants/variables";
import { appRoutes } from "config/AppRoutesConfig";
import homeService from "services/homeService";

//REDUX

import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import MarkdownText from "components/Atoms/MarkdownText/MarkdownText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import newsAndMediaService from "services/newsAndMediaService";
import formatDateToRomanian from "utils/formatDateToRomanian";
import { ScrollTargetWrapper } from "view/CampaignDetails/CampaignDetailsStyled";
import StrapiTreeText from "components/Atoms/StrapiTreeText/StrapiTreeText";

const EmergencyCommunicationDetails = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: DEVICE_TYPE.mobileHeader });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { id } = useParams<{ id: string }>();

  // STATE CONSTANTS
  const contentRefs = useRef([]);
  const skeletonCount = 3;
  const [copied, setCopied] = useState<boolean>(false);
  const headerImageWrapperRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [emergencyCommunication, setEmergencyCommunication] = useState<any>();
  const [anotherComunications, setAnotherComunications] = useState<any[]>();

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  const scrollToTop = () => {
    if (headerImageWrapperRef.current) {
      headerImageWrapperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleCopyToClipboard = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => console.error("Failed to copy URL: ", err));
    } else {
      try {
        const textArea = document.createElement("textarea");
        textArea.value = window.location.href;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Fallback: Failed to copy URL: ", err);
      }
    }
  };

  const openModal = (image: string) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    // setLoading(true);
    newsAndMediaService
      .getNewsArticlesById(id)
      .then((response) => {
        // console.log("getNewsArticlesById resp", response);
        setEmergencyCommunication(response.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });

    homeService
      .getNewsArticles(true)
      .then((response) => {
        // console.log(response?.data);
        setAnotherComunications(response?.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, [id]);

  return (
    <EmergencyCommunicationContainer>
      <HeaderImageWrapper ref={headerImageWrapperRef}>
        <HeaderImage src={evergencyPhoto} alt={"evergencyPhoto"} />
      </HeaderImageWrapper>
      <Body>
        <FirstColumn>
          <InsideFirstColumn>
            <BackToWrapper
              onClick={() => navigate(appRoutes.home)}
              biggerCursor={biggerCursor}
            >
              <BackToImage src={LeftArrow} alt="backIcon" />
              <BackToButton biggerCursor={biggerCursor}>
                <CustomText
                  text={t("view.emergencyCommunication.home")}
                  type={TextType.H4bold}
                  color={COLORS.RaisinBlack}
                />
              </BackToButton>
            </BackToWrapper>
            <SubTitle>
              <CustomText
                text={t("view.emergencyCommunication.emergencyCommunication")}
                type={TextType.H5bold}
                color={COLORS.VividAuburn}
              />
            </SubTitle>
            <TitleWrapper>
              <CustomText
                text={emergencyCommunication?.attributes?.title}
                type={TextType.H3}
              />
            </TitleWrapper>
            <WrapperTitles>
              <ImgLeft src={calendarIcon} />
              <WrapperTexts>
                <CenterLeftCard>
                  <CustomText
                    text={formatDateToRomanian(
                      emergencyCommunication?.attributes?.publishedAt
                    )}
                    type={TextType.P1}
                    color={COLORS.MetalicSilver}
                  />
                </CenterLeftCard>
              </WrapperTexts>
            </WrapperTitles>
            <LeftCard onClick={openModal}>
              <ImgLeftCard src={covidImg} />
            </LeftCard>
          </InsideFirstColumn>
        </FirstColumn>
        <SecondColumn>
          <ContentCard tabIndex={0}>
            {emergencyCommunication?.attributes?.content ? (
              <ScrollTargetWrapper
                ref={contentRefs.current[0]}
                id={emergencyCommunication?.id}
              >
                <ContentCard tabIndex={0}>
                  <CenterCardTitle></CenterCardTitle>
                  <StrapiTreeText
                    text={emergencyCommunication?.attributes?.content}
                  />
                </ContentCard>
              </ScrollTargetWrapper>
            ) : (
              <ContentCard tabIndex={0}>
                <Skeleton
                  width={"100%"}
                  count={105}
                  baseColor={COLORS.Background}
                  highlightColor={COLORS.Cultured}
                />
              </ContentCard>
            )}
          </ContentCard>
        </SecondColumn>
        <ThirdColumn>
          <InsideThirdColumn>
            <SocialMediaCard>
              <CustomText
                text={"SHARE"}
                type={TextType.H5}
                color={COLORS.Yellow}
              />
              <SocialMediaIcons>
                <FacebookShareButton url={window.location.href}>
                  <SocialMediaIcon src={facebookIcon} alt="facebookIcon" />
                </FacebookShareButton>
                <LinkedinShareButton url={window.location.href}>
                  <SocialMediaIcon src={linkedInIcon} alt="linkedInIcon" />
                </LinkedinShareButton>
                <CopyToClipboardWrapper onClick={handleCopyToClipboard}>
                  <SocialMediaIcon src={shareIcon} alt="shareIcon" />
                  {copied && (
                    <CopyToClipboardTooltip>
                      <CustomText
                        text={t(
                          "view.newsAndMedia.officialAnnouncementsDetails.copyClipboard"
                        )}
                        type={TextType.P2}
                        color={COLORS.RaisinBlack}
                      />
                    </CopyToClipboardTooltip>
                  )}
                </CopyToClipboardWrapper>
              </SocialMediaIcons>
            </SocialMediaCard>
            {/* <OtherGuidesCard>
              <CustomText
                text={t("view.emergencyCommunication.access")}
                type={TextType.H3}
              />
              <CustomText
                text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit"}
                type={TextType.P2}
              />
              <ButtonWrapper>
                <ButtonAtom
                  type={ButtonType.RedButton}
                  text={t("view.emergencyCommunication.majorEvents")}
                  hasArrow={true}
                  onClick={() => {
                    // TODO: navigate to major events
                    console.log("CLICKED");
                  }}
                />
              </ButtonWrapper>
            </OtherGuidesCard> */}
            <OtherGuidesCard>
              <CustomText
                text={t("view.emergencyCommunication.access")}
                type={TextType.H3}
              />
              {anotherComunications?.length > 0 ? (
                anotherComunications
                  .filter((event: any) => event?.id !== Number(id))
                  .slice(0, 3)
                  .map((event: any, index: number) => (
                    <OtherChapters key={index} biggerCursor={biggerCursor}>
                      <ImgStyled
                        src={WarningIcon}
                        alt={"imageOthercampaigns"}
                        loading="lazy" decoding="async"
                        onClick={() =>
                          navigate(appRoutes.eventDetails + event?.id)
                        }
                      />

                      <DetailsOtherEventsWrapper>
                        <OtherCampaignsContent
                          onClick={() =>
                            navigate(
                              appRoutes.emergencyCommunication + event?.id
                            )
                          }
                        >
                          <CustomText
                            text={event?.attributes?.title}
                            type={TextType.H5}
                            color={COLORS.RaisinBlack}
                          />
                        </OtherCampaignsContent>
                      </DetailsOtherEventsWrapper>
                    </OtherChapters>
                  ))
              ) : (
                <>
                  {[...Array(skeletonCount)].map((_, index) => (
                    <SkeletonWrapperOtherChapter key={index}>
                      <SkeletonWrapperChapter>
                        <Skeleton
                          count={1}
                          baseColor={COLORS.Background}
                          highlightColor={COLORS.Cultured}
                        />
                      </SkeletonWrapperChapter>
                    </SkeletonWrapperOtherChapter>
                  ))}
                </>
              )}
            </OtherGuidesCard>
          </InsideThirdColumn>
        </ThirdColumn>
      </Body>
      {!isMobile && isModalOpen && (
        <Modal onClick={closeModal}>
          <ModalContentWrapper>
            <ModalCloseButton onClick={closeModal}>
              <XImg src={XSign} alt="close" />
            </ModalCloseButton>
            <ModalContent>
              <ImgModal src={covidImg} alt="Selected" />
            </ModalContent>
          </ModalContentWrapper>
        </Modal>
      )}

      {isMobile && (
        <BackOnTopWrapper onClick={scrollToTop}>
          <BackOnTopImg src={ArrowUpIcon} alt="ArrowUpIcon" />
        </BackOnTopWrapper>
      )}
    </EmergencyCommunicationContainer>
  );
};

export default EmergencyCommunicationDetails;
